import Swal from 'sweetalert2'
import {
    GET_LIST_TO_CERTIFICATE, IS_LOADING_GET_LIST_CLASS_CERTIFICATE, GET_LIST_CLASS_CERTIFICATE, ADD_CLASS_CERTIFICATE, EDIT_CLASS_CERTIFICATE, DELETE_CLASS_CERTIFICATE, GET_CLASS_CERTIFICATE,
    IS_LOADING_LIST_STATE_CONCEPT_CERTIFICATE, CHANGE_STATE_CONCEPT_CERTIFICATE, GET_LIST_TYPES_CERTIFICATES, IS_LOADING_GET_LIST_TYPE_CERTIFICATE, ADD_TYPE_CERTIFICATE, GET_TYPE_CERTIFICATE,
    DELETE_TYPE_CERTIFICATE, EDIT_TYPE_CERTIFICATE, IS_LOADING_LIST_CONCEPT_CERTIFICATE, GET_LIST_CONCEPT_CERTIFICATE, IS_LOADING_LIMITS_LIST, EDIT_GENERAL_LIMIT, CREATE_GENERAL_LIMIT, GET_LIST_LIMIT,
    IS_LOADING_GET_AUTH_REQUEST, GET_AUTH_REQUEST, IS_LOADING_GET_AUTH_REQUEST_BY_ID, GET_AUTH_REQUEST_BY_ID,CHANGE_AUTH_STATE,IS_LOADING_CHANGE_STATE,
    GET_PENDING_AUTH_FRANCHISE,IS_LOADING_GET_PENDING_AUTH_FRANCHISE,IS_LOADING_AUTH_FRANCHISE_BY_ID,AUTH_FRANCHISE_BY_ID,
    CHANGE_FRANCHISE_STATE,IS_LOADING_CHANGE_STATE_FRAN,LOADING_REPRESENTATIVE_REQUEST, REPRESENTATIVE_REQUEST_SUCCESS, LOADING_REPRESENTATIVE_REQUEST_BY_ID,
    AUTH_REPRESENTATIVE_BY_ID_SUCCESS, LOADING_CHANGE_STATE_REPRE, CHANGE_REPRESENTATIVE_STATE
} from './types'
import {
    urlServer
} from '../../config/GlobalConstant'
import inMemoryJWT from '../../auth/inMemoryJwt';


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
});

/// Certificate classes to professional profile management

export const seeListToCertificate = (body, history) => async dispatch => {

    await fetch(`${urlServer}api/certificate/state-type`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_TO_CERTIFICATE,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const createClassCertificate = (body, history) => async dispatch => {

    await fetch(`${urlServer}api/certificate/class-create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_GET_LIST_CLASS_CERTIFICATE
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: ADD_CLASS_CERTIFICATE,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const seeListClassCertificate = (body, history) => async dispatch => {

    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_GET_LIST_CLASS_CERTIFICATE
    })
    await fetch(`${urlServer}api/certificate/classes`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    

    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_CLASS_CERTIFICATE,
                payload: respJson.data || []
            });

        })
        .catch(error => {
            console.log()
        })
}
export const getClassCertificate = (id) => async dispatch => {

    await fetch(`${urlServer}api/certificate/class-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_CLASS_CERTIFICATE,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editClassCertificate = (body, index, typeCertificate) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/certificate/class-update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_CLASS_CERTIFICATE
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_CLASS_CERTIFICATE,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteClassCertificate = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/certificate/class-delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_GET_LIST_CLASS_CERTIFICATE
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_CLASS_CERTIFICATE,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
/// Certificate types management

export const createTypeCertificate = (body, history) => async dispatch => {

    await fetch(`${urlServer}api/certificatetypes/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_GET_LIST_TYPE_CERTIFICATE
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: ADD_TYPE_CERTIFICATE,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const seeListTypesCertificates = (body, history) => async dispatch => {

    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_GET_LIST_TYPE_CERTIFICATE
    })
    await fetch(`${urlServer}api/certificatetypes/`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    

    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_TYPES_CERTIFICATES,
                payload: respJson.data || []
            });

        })
        .catch(error => {
            console.log()
        })
}
export const getTypeCertificate = (id) => async dispatch => {

    await fetch(`${urlServer}api/certificatetypes/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_TYPE_CERTIFICATE,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editTypeCertificate = (body, index) => async dispatch => {
    await fetch(`${urlServer}api/certificatetypes/update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_GET_LIST_TYPE_CERTIFICATE
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: EDIT_TYPE_CERTIFICATE,
                payload: {
                    index: index,
                    data: respJson.data
                }
            });
        })
        .catch(error => {
            console.log()
        })
}

export const deleteTypeCertificate = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/certificatetypes/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_GET_LIST_TYPE_CERTIFICATE
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_TYPE_CERTIFICATE,
                payload: index
            });

        })
        .catch(error => {
            console.log()
        })
}



export const getListConceptCertificate = (concept) => async dispatch => {

    await fetch(`${urlServer}api/certificate/class-by-concept`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(concept)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_LIST_CONCEPT_CERTIFICATE
            });
            dispatch({
                type: GET_LIST_CONCEPT_CERTIFICATE,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getAuthPending = (stateConcept) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_AUTH_REQUEST
    });
    await fetch(`${urlServer}adminuserauthrequests/get-pending`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(stateConcept)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: GET_AUTH_REQUEST,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getAuthRequestByID = (id) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_AUTH_REQUEST_BY_ID
    });
    await fetch(`${urlServer}userauthrequests/get-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            { requestID: id }
        )
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: GET_AUTH_REQUEST_BY_ID,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const changeStateAuthRequest = (id,state,history,argument) => async dispatch => {
    /* const history = useHistory() */
    dispatch({
        type: IS_LOADING_CHANGE_STATE
    });
    await fetch(`${urlServer}adminuserauthrequests/change-state`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            { 
                requestID: id,
                state: state,
                invalidationReason: argument
            }
        )
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: CHANGE_AUTH_STATE,
                    payload: respJson.data
                });
                 history.push('/Admin/CertificateStateConceptAdmin') 
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getPendingFranchisesRequest = () => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_PENDING_AUTH_FRANCHISE
    });
    await fetch(`${urlServer}adminfranchises/get-pending`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            
        )
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: GET_PENDING_AUTH_FRANCHISE,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const changeStateAuthFranRequest = (id,state,history,argument) => async dispatch => {
    /* const history = useHistory() */
    dispatch({
        type: IS_LOADING_CHANGE_STATE_FRAN
    });
    await fetch(`${urlServer}adminfranchises/change-state`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            { 
                requestID: id,
                state: state,
                invalidationReason: argument
            }
        )
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: CHANGE_FRANCHISE_STATE,
                    payload: respJson.data
                });
                 history.go(-1) 
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getFranchiseAuthRequestByID = (id) => async dispatch => {
    dispatch({
        type: IS_LOADING_AUTH_FRANCHISE_BY_ID
    });
    await fetch(`${urlServer}franchises/get-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            { franchiseID: id }
        )
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: AUTH_FRANCHISE_BY_ID,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getPendingRepresentativesRequest = () => async dispatch => {
    dispatch({
        type: LOADING_REPRESENTATIVE_REQUEST
    });
    await fetch(`${urlServer}adminrepresentatives/get-pending`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            
        )
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: REPRESENTATIVE_REQUEST_SUCCESS,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const getRepresentativeRequestByID = (id) => async dispatch => {
    dispatch({
        type: LOADING_REPRESENTATIVE_REQUEST_BY_ID
    });
    await fetch(`${urlServer}representatives/get-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            { representativeID: id }
        )
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: AUTH_REPRESENTATIVE_BY_ID_SUCCESS,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const changeStateRepresentativeRequest = (id,state,argument) => async dispatch => {
    /* const history = useHistory() */
    dispatch({
        type: LOADING_CHANGE_STATE_REPRE
    });
    await fetch(`${urlServer}adminrepresentatives/change-state`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            { 
                requestID: id,
                state: state,
                invalidationReason: argument
            }
        )
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: CHANGE_REPRESENTATIVE_STATE,
                    payload: respJson.data
                });
                /* history.push('/Admin/CertificateStateConceptAdmin') */
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud Aceptada'
                })
            }
        })
        .catch(error => {
            Toast.fire({
                icon: 'error',
                title: 'Error desconocido, comuniquese con el administrador'
            });
        })
}
export const changeStateConceptCertificate = (stateConcept, index,history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/certificate/change-state-admin`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(stateConcept)
    })
        .then(response => response.json())
        .then(respJson => {
            if(respJson.success){
                dispatch({
                    type: IS_LOADING_LIST_STATE_CONCEPT_CERTIFICATE
                });
                dispatch({
                    type: CHANGE_STATE_CONCEPT_CERTIFICATE,
                    payload: index
                });
                history.push('/CertificateStateConceptAdmin')
            }
            console.log()
         
        })
        .catch(error => {
            console.log()
        })
}


/// General Limits Auth management 
export const createLimit = (body, history) => async dispatch => {

    await fetch(`${urlServer}api/generallimit/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_LIMITS_LIST
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: CREATE_GENERAL_LIMIT,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editLimit = (body, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/generallimit/update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            console.log()
            {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIMITS_LIST
                })
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_GENERAL_LIMIT,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeGeneralLimitList = (body, history) => async dispatch => {

    await fetch(`${urlServer}api/generallimit/`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_LIMITS_LIST
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_LIMIT,
                payload: respJson.data[0]
            });
        })
        .catch(error => {
            console.log()
        })
}

export const deleteLimit = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/xxx`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_GET_LIST_TYPE_CERTIFICATE
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_TYPE_CERTIFICATE,
                payload: index
            });

        })
        .catch(error => {
            console.log()
        })
}

export const getLimit = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/generallimit/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_GET_LIST_TYPE_CERTIFICATE
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_TYPE_CERTIFICATE,
                payload: index
            });

        })
        .catch(error => {
            console.log()
        })
}


